<template>
  <section class="result">
    <div class="result__icon">
      <van-image width="100" height="100" :src="success_img" />
    </div>
    <div class="result__title">预约成功</div>
    <div class="result__remark">
      请在规定时间内前往停车场。
    </div>
    <!-- <div class="result__countdown">
      自动退出本页面:
      <van-count-down @finish="handleRefresh" :time="Countdown" style="color:#FF3366;" ref="countDown" />
    </div> -->
  </section>
</template>

<script>
import success_img from '@/assets/payment-related/img_pay_success.png'
import { mapGetters } from 'vuex'
import { Image, CountDown, Button } from 'vant'
export default {
  name: 'InvoiceSuccess',
  computed: {
    ...mapGetters([
      'invoiceParkId',//parkid
    ])
  },
  components: {
    [Image.name]: Image,
    [CountDown.name]: CountDown,
    [Button.name]: Button,
  },
  data () {
    return {
      success_img,
      Countdown: 15 * 1000,
    }
  },
  methods: {
    // handleRefresh () {
    //   this.$router.push({ name: 'Personal-Center' })
    // }
  }
}
</script>

<style lang="scss" scoped>
.result {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  text-align: center;
  color: #444444;
  padding-top: 10vh;
  &__title {
    font-size: 22px;
    line-height: 48px;
    font-family: PingFang-SC-Bold;
    font-weight: bold;
    letter-spacing: 1.75px;
  }
  &__remark {
    font-size: 14px;
    font-family: PingFang-SC-Medium;
    letter-spacing: 1.25px;
    font-weight: bold;
  }
  &__tips {
    font-size: 14px;
    line-height: 24px;
    font-family: PingFang-SC-Medium;
    letter-spacing: 1.25px;
    font-weight: bold;
  }
  &__countdown {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    line-height: 24px;
    font-family: PingFang-SC-Medium;
    letter-spacing: 1.25px;
    font-weight: bold;
    text-align: center;
  }
  &__orderInfo {
    font-size: 14px;
    line-height: 24px;
    font-family: PingFang-SC-Medium;
    letter-spacing: 1.25px;
    font-weight: bold;
  }
}
</style>
